import BookmarkPage from "./BookmarkPage";

// check for bookmarks page and render list
if (document.querySelector(".bookmarks__wrapper")) {
  // eslint-disable-next-line no-unused-vars
  new BookmarkPage();
}
